export default __webpack_public_path__ + "static/media/my-treat.79d528fe.webp";